type SetList = {
  title: string;
  artist: string;
  text: string;
  lyric: string;
  link?: string;
};

export const setList: SetList[] = [
  {
    title: "雨宿りの白昼夢",
    artist: "吉田雪乃",
    text: "オープニングのために歌詞なしの曲を、初めてDTM (音楽を作れるPCソフト)を使って、松下さんとやりとりしながら作ってみました。\n...やってみたらできるもんですね笑\nオープニング曲なのでとっても短いですが、今回のライブの始まりの音をお聞きください。",
    lyric: "",
  },
  {
    title: "追想",
    artist: "吉田雪乃",
    text: "2番目に作った曲、完成した曲としては初めての曲。\n心の暗い部分をそのまま素直に取り出して。きっと誰しもが心当たりがあるんじゃないかと思うようなそんな部分。\n音量要注意です！！！",
    lyric:
      "ゆらゆらとこのまま 流されていたいわ\n真っ暗な気持ちを 後ろに隠して\nばらばらと散ってく 気持ちの行き場は\nまだ見つからないまま\n\nああ 嫌なことばっか見つけてしまうの\nああ まだ このまま居たくて 痛くて\n暗く染めてしまうの\n\nひたひたに浸けられた水の中では\n自由な温もりを感じていたいの\nぎらぎらな輝きを遠くに眺めて\n目を瞑って動けないまま\n\nああ まだ 心に宿った濁った記憶が\nああ まだ “今”を汚して 縛って\n固く閉じてしまうの\n\n取り繕って笑顔重ね 楽しさがわからなくって\n知らないふりを続けても 気になって仕方なくて\n正解だけを探し続け “正しさ”で固めてく\nそれらを全て捨て去っても\n\nああ 今 心に灯った光のかけらが\nああ 立ち向かう勇気の糧になるはずだから\n\nああ まだ見えない明日を目指して\nああ この先も もがいてあがいて進んでいくの",
  },
  {
    title: "Seven Years",
    artist: "Norah Jones",
    text: "当時のパートナーだったベーシストのLee AlexanderがNorah Jonesの幼い頃の映像を見てインスピレーションを受けた曲らしいです。\n7歳という曲なので、すごく可愛らしくて自由な反面、なんだか寂しげで、成長の片隅に感じていたのかもしれない孤独さを想像して惹かれました。",
    lyric:
      "Spinning, laughing, dancing to\nHer favorite song\nA little girl with nothing wrong\nIs all alone\n\nEyes wide open\nAlways hoping for the sun\nAnd she′ll sing her song to anyone\nThat comes along\n\nFragile as a leaf in Autumn\nJust fallin' to the ground\nWithout a sound\n\nCrooked little smile on her face\nTells a tale of grace\nThat′s all her own\n\nFragile as a leaf in Autumn\nJust fallin' to the ground\nWithout a sound\n\nSpinning, laughing, dancing to her\nFavorite song\nWell, she's a little girl with nothing wrong\nAnd she′s all alone\nA little girl with nothing wrong\nAnd she′s all alone",
    link: "https://lyrics.lyricfind.com/",
  },
  {
    title: "漂",
    artist: "吉田雪乃",
    text: "初めてライブをした後、非日常の空間に行ったように感じて、いつもの日常に戻れないようなそんな感覚になったものを書いた曲。\nそして、初めて1人でコードをつけてみた曲です。\nちょっと前に自分の中で密かなブームになってたくさん歌ってました笑",
    lyric:
      "いつもの道が寂しすぎて\nどうでもいいような話をする\n言葉にできない感情の霧\nひとつひとつを噛み締めて\n\n気持ちの行き場を整理する\n\nきっとまだ日常の流れに乗れないだけ\n好きも嫌いもすべて中に隠して\n感じないように感じないように押し殺す\n今が終わらないでと願ってる\n\n素直になること苦手になって\nどこかに置いてきたんだろな\n寂しさも悲しさも楽しさも愛しさも\n全部大事なものなのに\n\n“自分”を見るのが怖いんだ\n\nきっとまだやれるはずだとどこかで願ってる\n終わりの音を聞きたくなくて\n寂しいけど寂しさはまだ感じたくないから\n楽しい余韻にまだ浸らせて\n\nやり残したことがあるんだ\nわかっているんでしょ？\nやりたい気持ちがここにあるんだ\nきづいているでしょ？\nでも でも まだ言い訳を重ねている\n\nきっとこの世界は美しさで溢れていて\n見え方次第で変わっていくんだ\n当たり前の顔をして痛みはやってくるけど\nここで終わりにしたくない\n\nきっとまだ日常の流れに乗れないだけ\n好きも嫌いもすべて中に隠して\n感じないように感じないように押し殺す\n今が終わらないでと願ってる",
  },
  {
    title: "明日への手紙",
    artist: "手嶌葵",
    text: "フジテレビ系月9ドラマ『いつかこの恋を思い出してきっと泣いてしまう』の主題歌。松下さん推しの曲。\nレパートリーを増やすために、手嶌葵さんのカバーアルバムをいろいろ聴いていたのですが、ご本人の曲は歌ったことがなくて。そんなときにこの曲を勧めてもらい、歌ってみることになりました。\n今日1番の綺麗な曲です。",
    lyric:
      "元気でいますか\n大事な人はできましたか\nいつか夢は叶いますか\nこの道の先で\n\n覚えていますか\n揺れる麦の穂 あの夕映え\n地平線 続く空を探し続けていた\n\n明日を描こうともがきながら\n今夢の中へ\n形ないものの輝きを\nそっとそっと抱きしめて\n進むの\n\n笑っていますか\nあの日のように無邪気な目で\n寒い夜も雨の朝もきっとあったでしょう\n\nふるさとの街は帰る場所ならここにあると\nいつだって変わらずに あなたを待っている\n\n明日を描くことを止めないで\n今夢の中へ\n大切な人のぬくもりを\nずっとずっと忘れずに\n進むの\n\n人は迷いながら揺れながら\n歩いてゆく\n二度とない時の輝きを\n見つめていたい\n\n明日を描こうともがきながら\n今夢の中で\n形ないものの輝きを\nそっとそっと抱きしめて\n進むの\n\n",
    link: "https://lyrics.lyricfind.com/",
  },
  {
    title: "いつかの想い出に似た景色",
    artist: "吉田雪乃",
    text: "唯一のPOPS!って感じの曲で、唯一の恋愛の話。もうしばらくはこういう曲は書かないな、そのうちやらなくなるかもな、と思ってる曲です、実は。笑\n今回のライブで唯一の元気曲 (?) なので、楽しんでいただけたらと思います。",
    lyric:
      "初めて君に出会ったとき\n僕はパッとしないやつで\n目立つやつじゃなかったし\n覚えられてたかなぁ\n恋には疎くて\n僕には無理って諦めてた\n\nでも何かいつもと違ったんだ\nこれで終わりにしたくない\nなんでだろ？ なんだこれ？ 止まらないな\n\nあのとき勇気を出して聞いたLINE\n終わりにしたくなかったから\n必死に繋ぎ止めてたんだ\nもしかしたら気づいてたかなぁ\n変なやつって思ったかなぁ\nでもいいんだ 嬉しかったから\nあの日々が懐かしいや\n\n違和感があったのは\n会う回数が減った時\n心の距離もちょっとずつ\n離れていっていたのかな\n\nでも僕は気づかなかったんだ\nいや気づきたくなかった\nだってまだ だってまだ そばにいさせてよ\n\n一緒に2人のりで自転車で駆けた\nあの道は桜が咲いていた\nふざけ合って笑い合っていたよね\nテイクアウトのピザ大きくて\n食べ切れるかなぁなんて話して\n楽しすぎてばかだったよなぁ\nあの日々がもう遠いや\n\nちょっとだけ ちょっとだけ 伝えさせて\n\nあのとき君が僕に向けた笑顔は\n僕の胸にひどく刺さった\n全部僕が悪かったのに\n不安になってしまったんだ\n君を試してしまったんだ\n勝手で本当 ばかだよなぁ\n\n長い月日を過ごしたこと\nかけがえのない時間たちは\n忘れたくない宝物で\nこの先もずっと照らしていくんだ\n僕の中で踊っていくんだ\nそれなら許してくれるかなぁ\nあの日々が愛しいな",
  },
  {
    title: "間色",
    artist: "吉田雪乃",
    text: "「あわいろ」と読みます。\n夢と現実、朝と夜、そんな間の色でいっぱいのこの世界を。\nわたし自身なんだか飲み込めてなかったこの曲は、最近、「この曲いいね」と言ってもらうことが増えて、そこで改めてきちんと中身を見てみると、輪郭がわかったようなそんな曲。",
    lyric:
      "おはよう世界\n空が穏やかにうたう\n僕の心は曇ってるのに\n\nおはよう世界\n君は楽しそうだな\n何も考えてないふりして\n\n泣いて 笑って 転んで 起きて\nそんな繰り返しだな\n\nきっときっと大丈夫\n空が見守っている\nずっとずっと夢に見た\n眩いほどの光\n\nおやすみ世界\n寝静まる湿った空気に\n僕の心を委ねてみる\n\nおやすみ世界\n冷たいふりをしないでよ\n巡り巡る片隅で\n\n疲れて 眠っても 明日はやってくるの\nそんな繰り返しだな\n\nきっときっと大丈夫\n空が見守っている\nずっとずっと夢に見た\n眩いほどの光\n\n儚く 残酷な 現実に思い馳せて\nそんな繰り返しだな\n\nずっとずっと考えてる\nこの世界の続く先\nいつかいつか届くかな\n君のその温もりに",
  },
  {
    title: "Don't look back in anger",
    artist: "Oasis",
    text: "「羊毛とおはな」さんという方がカバーをしていたのをきっかけに知りました。そちらのアレンジもとても素敵で、原曲を聴いた時はびっくりしました笑\nOasis、10月に来日するみたいですね！！",
    lyric: "",
  },
  {
    title: "静かな夜に少しの空白を",
    artist: "吉田雪乃",
    text: "日暮里BarPortoでの弾き語りライブのテーマとして作った曲。\n弾き語りライブは去年の12月から2ヶ月に1度くらいの頻度でやらせていただいていて、3回目のライブの時に作りました。まだ新入りです笑\n聴いてくれる人はこんな気持ちなんだろうか、と空想と想像をしながら。",
    lyric:
      "寒ざめた季節の中\n朝焼けに恋をした\n白く変わる吐息が\n光に晒されていく\n\n幻想的な景色の中で\n自分の思考が追いつけないまま\n心だけが温まっていく\nそんな気がした\n\n星の見えない空の下で\nキミを想って祈りを込めた\nキミが描いた景色は\n今のボクに見えてるのかな\n\n遠くに見える下弦の月と\n街の眩い光にまぎれて\n少しだけ温まっていく\nそんな気がした\n\n溢れ出す声に溢れ出す涙に\n一体何を託せばいい？\n名のない気持ちはこのままどこかに\n飛んでいくことはないのかもな\n\n色のない空を描いても僕ら\n鮮やかな空を望んでいる\n鳴り響く声を立ち籠める願いに変えて\n今",
  },

  {
    title: "エイリアンズ",
    artist: "キリンジ",
    text: '2年前、お世話になってるオープンマイクで歌ってる方がいて知った曲。わたしの好きなジャズボーカルの方もカバーされていて、それはそれは素敵すぎて、大きな憧れとと嫉妬を少ししました。笑\n都会の片隅で生きる恋人たちの孤独と連帯を、"エイリアンズ(異星人)"という比喩で描いているんだとか。',
    lyric:
      "遥か空に旅客機 音もなく\n公団の屋根の上 どこへ行く\n\n誰かの不機嫌も 寝静まる夜さ\nバイパスの澄んだ空気と 僕の町\n\n泣かないでくれ ダーリン\nほら 月明かりが\n長い夜に寝つけない二人の額を撫でて\n\nまるで僕らはエイリアンズ\n禁断の実 ほおばっては\n月の裏を夢みて\nキミが好きだよ エイリアン\nこの星のこの僻地で\n魔法をかけてみせるさ\nいいかい\n\nどこかで不揃いな 遠吠え\n仮面のようなスポーツカーが\n火を吐いた\n\n笑っておくれ ダーリン\nほら 素晴らしい夜に\n僕の短所をジョークにしても眉をひそめないで\n\nそうさ僕らはエイリアンズ\n街灯に沿って歩けば\nごらん 新世界のようさ\nキミが好きだよ エイリアン\n無いものねだりもキスで\n魔法のように解けるさ\nいつか\n\n踊ろうよ さぁ ダーリン\nラストダンスを\n暗いニュースが\n日の出とともに町に降る前に\n\nまるで僕らはエイリアンズ\n禁断の実 ほおばっては\n月の裏を夢みて\nキミを愛してる エイリアン\nこの星の僻地の僕らに\n魔法をかけてみせるさ\n大好さエイリアン\nわかるかい",
    link: "https://lyrics.lyricfind.com/",
  },
  {
    title: "巡",
    artist: "藤原さくら",
    text: "去年、学生の頃に足を運んでいたピアノトリオを聴きに行ったのですが、そのドラムの方がこの曲でも叩かれていることをきっかけに知りました。\n原曲のバンドメンバーが強強メンバーなので、ピアノ一台でやる曲じゃないのですが笑\n松下さんがめちゃくちゃすごいことしてるので、大注目してください！\n",
    lyric:
      "待ち合わせしようか\n今夜は\n帰れる場所なんてないんだから\n\nあなたからもらった全部を\n捨てていくの\n\n一つ 一つ\n森の中へ落として\n目印になれば\nまたあそこで会えるね\n足跡だけじゃ足りないよ\n\nまだ\n伝わらないや\n\n飽きもせずに\nくるくる\n目が回るのよ\n\n瘡蓋剥がしてまで\n何がしたいんだろう\n\n(Ooh ooh ooh ooh)\n\n流れてる水だけ綺麗で\n嫌気がさしてくるなぁ\n笑えない\n\n巡ってる季節を止めたの\n千切れてく\n\n私だけ この心\nここに埋めて\n掘りおこさないで\nいつまでも\nあなただけ\nその居場所を知っていてよ\n\n飽きもせずに\nくるくる\nまたここなの\nわざと迷ってる\n時計の針が止まる\n今どこなの\n知りたくはない",
    link: "https://lyrics.lyricfind.com/",
  },
  {
    title: "たしかな。",
    artist: "吉田雪乃",
    text: "去年のライブのテーマでもあった曲。たしかな「存在」「意味」「軌跡」…そんな祈りを込めて。\n最近はSNSも頑張っていて、こちらの曲はYoutubeにフルで載ってます。もしよければ聴いてみてください！",
    lyric:
      "どっぷり浸かる真夜中に\n1日の記憶が押し寄せる\nできることなら忘れられたいと\n破れそうな声を抑えてる\n\nどこまでも遠くて どこまでも近くて\nたしかに「在る」そんなもの\n\nきっとどこかに忘れられたら\n僕はこのまま何になれるだろう？\n「いつかいつかは」と願っては\nその「いつか」はいつ来るのだろう\n\n虚勢を張るそんな日々を\n疲れたとも思わず歩いてる\nここしか道がないからと\n他に何も見えず進んでた\n\n誰かを拒んでは離れるのが怖くて\n積み重ねた嘘の山はずっとそこに「在る」\n\n「1人で抱えられるほど僕は強くない」\n僕の中の「ぼく」がそう叫んでる\n「1人で抱えられるほど僕らは強くない」\n君の中の「きみ」もそう叫んでる\n\n作り上げたものがいつか\n「ぼく」自身だと気づいたなら\nヒトは誰しもが不完全で\n人間味溢れた 愛しいほどに",
  },

  // {
  //   title: "幽かな陽",
  //   artist: "吉田雪乃",
  //   text: "「かすかなひ」と読みます。\n2年前、ライブをするぞ！と意気込んだとき、あのときの自分が込められる最大の感謝を込めた曲。\n1曲だけ演奏していいよって言われたら高確率でこれかもしれない。笑",
  //   lyric:
  //     "はしゃいでる陽の光を浴びて\n遅めの朝に目が覚める\n顔出した花と笑い合って 1日が始まる\n\nたくさんの命が混じり合い\n遠くで空が眺めてる\nそんな穏やかな日を想って\n今日もいい日だったと1日を終えるの\n\nはるか昔のこと 生まれてきた日のこと\n喜びも悲しみも望んで来たんだろう\n気づかないくらいの当たり前の中で\n僕は哀を知った\n\n新しい出会いの裏側に\nいくつも別れを繰り返す\nそんな儚い日を思い出して\n今日もいい日だったと1日を終えるの\n\nはるか昔のこと 生まれてきた日のこと\n愛しさも寂しさも望んで来たんだろう\n家族や友達や恋人ができて\n僕は愛を知った\n\nここまで来れたのは 誰かの繋がりで\n気づけば周りにたくさんの人がいた\n\n何気ない日常に散らばる光たちを\n無意識に大切に集めてきたんだ\nここまでの道のりは1人じゃないから\n僕は\n\nはるか昔のこと 生まれてきた日のこと\n喜びも悲しみも望んで来たんだろう\n気づかないくらいの当たり前の中で\n僕は愛を知った\n\n僕は愛を知った ",
  // },
];
